<template>
	<footer v-if="showFooter || showPartnersFooter" class="new-footer">
		<section v-if="showFooter" class="new-footer__main">
			<div class="new-footer__inner new-layout-container">
				<div class="new-footer__top" :class="{'new-footer__top--without-logo': !showBlumarLogo}">
					<router-link v-if="showBlumarLogo" class="new-footer__logo" to="/calendar" aria-label="Blumar Congressos e Eventos">
						<img :src="footerAsset('logo_blumar.png')" alt="Blumar Congressos e Eventos">
					</router-link>

					<nav class="new-footer__nav" aria-label="Menu do rodape">
						<router-link exact to="/company-profile">{{navbar.companyProfile}}</router-link>
						<span></span>
						<router-link exact to="/accommodation">{{navbar.accommodation}}</router-link>
						<span></span>
						<a :href="localToursUrl">{{navbar.localTours}}</a>
						<span></span>
						<a :href="resumeUrl">{{footer.portfolioLabel}}</a>
					</nav>

					<div class="new-footer__social">
						<span>{{footer.socialLabel}}</span>
						<a
							v-for="social in socialLinks"
							:key="social.alt"
							:href="social.href"
							target="_blank"
							rel="noopener noreferrer"
						>
							<img :src="footerAsset(social.file)" :alt="social.alt">
						</a>
					</div>
				</div>

				<div class="new-footer__contact">
					<div class="new-footer__contact-list">
						<span class="new-footer__contact-title">{{footer.contactLabel}}</span>
						<a class="new-footer__email" href="mailto:eventos@blumar.com.br">
							<img src="/static/buttons/new/email.svg" alt="">
							email
						</a>
						<a href="tel:+552121429315">
							<img :src="footerAsset('footer-phone.png')" alt="">
							21 2142 9315
						</a>
						<a v-if="showWhatsapp" href="https://wa.me/5521991144780" target="_blank" rel="noopener noreferrer">
							<img :src="footerAsset('footer-whatsapp.png')" alt="">
							21 99114 4780
						</a>
					</div>

					<address>{{address}}</address>
				</div>
			</div>
		</section>

		<section v-if="showPartnersFooter" class="new-footer__logos" aria-label="Selos e parceiros">
			<div class="new-footer__logos-inner new-layout-container">
				<div class="new-footer__award">
					<a :href="caioAwardUrl" target="_blank" rel="noopener noreferrer">
						<img class="new-footer__award-main" :src="footerAsset('caio.png')" alt="Premio Caio">
					</a>

					<div class="new-footer__award-stack">
						<img :src="footerAsset('caio_premios.png')" alt="A Blumar conquistou 13 premios Caio">
						<a :href="caioAwardUrl" target="_blank" rel="noopener noreferrer">
							<img :src="footerAsset('busca_ano.png')" alt="Confira aqui">
						</a>
					</div>
				</div>

				<img
					v-for="partner in partnerLogos"
					:key="partner"
					class="new-footer__partner"
					:src="footerAsset(partner)"
					alt=""
				>
			</div>
		</section>
	</footer>
</template>

<script>
import { translate } from '../../assets/translations';

export default {
	props: {
		event: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			localToursUrl: 'https://eventos.blumar.com.br/local-tours', //temp
			resumeUrl: 'https://eventos.blumar.com.br/resume', //temp
			caioAwardUrl: 'https://www.eventos.blumar.com.br/caio-award', //temp
			socialLinks: [
				{ href: 'https://bit.ly/blumar_eventos_facebook', file: 'fb.png', alt: 'Facebook' },
				{ href: 'https://bit.ly/blumar_eventos_instagram', file: 'ig.png', alt: 'Instagram' },
				{ href: 'http://bit.ly/linkedin_blumar_eventos', file: 'linkedin.png', alt: 'Linkedin' },
			],
			partnerLogos: [
				'rio.png',
				'iguassu.png',
				'sao_paulo.png',
				'iata.png',
				'zurich.png',
				'secured.png',
				'embratur.png',
				'brasil01.png',
				'brasil02.png',
				'convention.png',
			],
		};
	},
	computed: {
		showBlumarLogo() {
			return !this.event || this.event.showBlumarLogo !== false;
		},
		showFooter() {
			return !this.event || Boolean(this.event.showFooter);
		},
		showPartnersFooter() {
			return !this.event || Boolean(this.event.showPartnersFooter);
		},
		showWhatsapp() {
			return !this.event || this.event.showWhatsapp !== false;
		},
		translation() {
			return translate(this.$store.state.language);
		},
		navbar() {
			return this.translation.navbar;
		},
		footer() {
			return this.translation.footer;
		},
		address() {
			const footerAddress = this.footer.address || '';
			return footerAddress
				.replace(/^Blumar Brasil - /, '')
				.replace(/ - Tel:.*/, '');
		},
	},
	methods: {
		footerAsset(fileName) {
			return `/static/buttons/new/footer/${fileName}`;
		},
	},
};
</script>

<style scoped lang="scss">
.new-footer {
	background: #0b3a52;
	color: #ffffff;
	font-size: 13px;
	letter-spacing: 0;
	max-width: 100%;
	overflow-x: hidden;
}

.new-footer__main {
	background: #0b3a52;
}

.new-footer__top {
	position: relative;
	display: grid;
	grid-template-columns: 180px minmax(0, 1fr) auto;
	align-items: center;
	gap: 28px;
	min-height: 100px;
}

.new-footer__top--without-logo {
	grid-template-columns: minmax(0, 1fr) auto;
}

.new-footer__top::after {
	content: '';
	position: absolute;
	bottom: 0;
	left: 50%;
	width: 100vw;
	height: 1px;
	background: rgba(255, 255, 255, .72);
	transform: translateX(-50%);
}

.new-footer__logo img {
	display: block;
	width: 96px;
	height: auto;
}

.new-footer__nav {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-wrap: wrap;
	gap: 10px;
	color: #E89127;
	font-size: 16px;
	font-weight: 700;
	line-height: 19px;
	text-transform: uppercase;
}

.new-footer__nav a {
	color: #E89127;
	text-decoration: none;
	white-space: nowrap;
}

.new-footer__nav a:hover,
.new-footer__nav a:focus-visible,
.new-footer__nav a.active {
	color: #ffffff;
}

.new-footer__nav span {
	width: 1px;
	height: 10px;
	background: #E89127;
}

.new-footer__social {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 13px;
	white-space: nowrap;
}

.new-footer__social span {
	color: #66ACC6;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
}

.new-footer__social img {
	display: block;
	width: auto;
	height: 26px;
}

.new-footer__contact {
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
	gap: 30px;
	min-height: 80px;
}

.new-footer__contact-list {
	display: flex;
	flex-direction: row;
	align-items: center;
	flex-wrap: wrap;
	gap: 24px;
}

.new-footer__contact-title {
	display: inline-flex;
	width: 78px;
	color: #ffffff;
	font-size: 16px;
	font-weight: 400;
	line-height: 16px;
}

.new-footer__contact a {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	color: #ffffff;
	font-size: 18px;
	font-weight: 700;
	line-height: 20px;
	text-decoration: none;
	white-space: nowrap;
}

.new-footer__contact a:hover,
.new-footer__contact a:focus-visible {
	color: #E89127;
}

.new-footer__contact img {
	display: block;
	width: 16px;
	height: 16px;
	object-fit: contain;
}

.new-footer__contact .new-footer__email {
	text-decoration: underline;
}

.new-footer__contact .new-footer__email img {
	filter: brightness(0) invert(1);
}

.new-footer address {
	margin: 0;
	color: rgba(255, 255, 255, .78);
	font-size: 14px;
	font-weight: 400;
	font-style: normal;
	line-height: 16px;
	text-align: right;
}

.new-footer__logos {
	background: #EEEEEE;
}

.new-footer__logos-inner {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 40px;
	padding: 20px 0;
	flex-wrap: nowrap;
}

.new-footer__award {
	display: flex;
	align-items: center;
	gap: 10px;
	margin-right: 12px;
}

.new-footer__award-main {
	display: block;
	width: auto;
	height: 58px;
}

.new-footer__award-stack {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 4px;
}

.new-footer__award-stack img {
	display: block;
	max-width: 132px;
	height: auto;
}

.new-footer__partner {
	display: block;
	width: auto;
	max-width: 88px;
	max-height: 42px;
	object-fit: contain;
}

@media (max-width: 1300px) {
	.new-footer__contact {
		justify-content: center;
		margin-top: 1%;
		margin-bottom: 1%;
	}

	.new-footer__contact-list {
		justify-content: center;
	}

	.new-footer__logos-inner {
		justify-content: center;
		flex-wrap: wrap;
		gap: 30px;
	}
}

@media (max-width: 900px) {
	.new-footer__top {
		grid-template-columns: 1fr;
		justify-items: center;
		gap: 18px;
		padding: 24px 0 22px;
	}

	.new-footer__social {
		justify-content: center;
	}

	.new-footer__contact {
		justify-content: center;
		gap: 14px;
		padding: 20px 0;
	}

	.new-footer__contact-list {
		justify-content: center;
	}

	.new-footer address {
		text-align: center;
	}
}

@media (max-width: 620px) {
	.new-footer__nav {
		gap: 8px;
	}

	.new-footer__contact-list {
		flex-direction: row;
		align-items: center;
		justify-content: center;
		gap: 12px;
	}

	.new-footer__contact-title {
		justify-content: center;
		width: auto;
	}

	.new-footer__logos-inner {
		flex-wrap: wrap;
		gap: 18px 20px;
		justify-content: center;
		padding: 20px 0;
	}

	.new-footer__award {
		justify-content: center;
		width: 100%;
		margin-right: 0;
	}

	.new-footer__partner {
		max-width: 70px;
		max-height: 34px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/shared/Footer.vue